import { CSSProperties, ReactElement } from "react";
import { IParentSize } from "../../../types";
// import FilterComponentBase from "../../../components/filterComponentBase";

interface IProps {
  parentSize: IParentSize;
}

const ReportPage = ({ parentSize }: IProps): ReactElement => {

  const gridStyle: CSSProperties = {
    position: "relative",
    ...parentSize,
    gridTemplateRows: "auto auto 1fr",
    gridTemplateColumns: "1fr",
    alignItems: "stretch"
  };

  // const contentStyle = {
  //   gridTemplateColumns: "1fr",
  //   gridTemplateRows: "auto 1fr",
  //   gridRow: "3 / span 1",
  //   overflow: "hidden"
  // };

  return (
    <div className="display-grid" style={gridStyle}>
      RM
    </div>
  );
};

export default ReportPage;